module.exports = __webpack_public_path__ + "img/standing.4de60168.png";